import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getGraduationPlans = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getGradPlanPageBySlug = ({
  params = {},
  version = 'v1',
  gradPlanSlug,
} = {}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/slug/${gradPlanSlug}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addProgramSlot = ({ version = 'v1', gradPlanUUID, payload }) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/program/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const editProgramSlot = ({ version = 'v1', gradPlanUUID, payload }) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/program/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const removeProgramSlot = ({
  version = 'v1',
  gradPlanUUID,
  programSlotUUID,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/program/${programSlotUUID}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateGradPlanElectiveChoice = ({
  version = 'v1',
  gradPlanUUID,
  hasElectivePicker,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/elective-requirement/`,
      method: RequestMethod.PATCH,
      data: { hasElectivePicker },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addGradPlanTopLevelRequirement = ({
  version = 'v1',
  gradPlanUUID,
  updatedTLRequirement,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/top-level-requirement/`,
      method: RequestMethod.POST,
      data: updatedTLRequirement,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const editGradPlanTopLevelRequirement = ({
  version = 'v1',
  gradPlanUUID,
  updatedTLRequirement,
  updatingRequirementUUID,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/top-level-requirements/`,
      method: RequestMethod.PATCH,
      data: updatedTLRequirement,
      params: {
        updatingRequirementUUID,
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);
